import MapFeature from './MapFeature'
import { SearchOnMapMoveControl } from '../controls'

/**
 * Add a toggle control and if enabled, handle bounds changes.
 */
export default class SearchOnMapMove extends MapFeature {

    /** @type {NavigationControl} */
    _searchOnMapMoveControl

    constructor() {
        super()

        this._searchOnMapMoveControl = new SearchOnMapMoveControl(true)

        this._handleBoundsChange = this._handleBoundsChange.bind(this)
        this._searchOnMapMoveControl.addEventListener('change', this._handleBoundsChange)
    }

    _onAdd(map) {
        map.addControl(this._searchOnMapMoveControl, 'top-left')
        map.on('moveend', this._handleBoundsChange)
        map.on('zoomend', this._handleBoundsChange)
    }

    _onRemove(map) {
        map.removeControl(this._searchOnMapMoveControl)
        map.off('moveend', this._handleBoundsChange)
        map.off('zoomend', this._handleBoundsChange)
    }

    _handleBoundsChange(e) {
        if (this.isEnabled && !e.implicit) {
            this._dispatchEvent('mapmovesearch')
        }
    }

    get isEnabled() {
        return this._searchOnMapMoveControl.value
    }

}
